import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"close\"><title>close</title><g id=\"close_mask-2\"><path id=\"close_path-1\" d=\"M10,7.11,16.51.6A2,2,0,1,1,19.4,3.49L12.89,10l6.51,6.51a2,2,0,1,1-2.89,2.89L10,12.89,3.49,19.4A2,2,0,1,1,.6,16.51L7.11,10,.6,3.49A2,2,0,0,1,3.49.6Z\" transform=\"translate(0 0)\" /></g><g id=\"close_Symbols\"><g id=\"close_atoms_icons_small_close\" data-name=\"atoms/icons/small/close\"><g id=\"close_colors_navy-blue\" data-name=\"colors/navy-blue\"><g id=\"close_Mask\"><path id=\"close_path-1-2\" data-name=\"path-1\" d=\"M10,7.11,16.51.6A2,2,0,1,1,19.4,3.49L12.89,10l6.51,6.51a2,2,0,1,1-2.89,2.89L10,12.89,3.49,19.4A2,2,0,1,1,.6,16.51L7.11,10,.6,3.49A2,2,0,0,1,3.49.6Z\" transform=\"translate(0 0)\" /></g></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/close.svg
// module id = usbd
// module chunks = 268